/* global document, window, webfxPropertyManagerData */
import { Loader } from '@googlemaps/js-api-loader'
import { MarkerClusterer } from '@googlemaps/markerclusterer'
import { PropertyBlock } from './PropertyBlock'
import { GoogleMap } from './GoogleMap'
import { getActiveFacets } from '../utils/FacetWp'


/**
 * Class for enscapsulating main listings functionality
 *
 */
export class MainListings {

	
	node
	nodeMap
	nodeListings

	mapSection
	mapToggle
	
	addonData = {}
	propertyBlocks = []

	googleMap

	default_center
	default_zoom

	restButton


	/**
	 * Constructor
	 *
	 * @param {HTMLElement} node Base node element
	 */
	constructor( node ) {
		this.node = node
		this.nodeMap = node.querySelector( '.js-main-listings-map' )
		this.nodeListings = node.querySelector( '.js-main-listings-list' )
		this.mapSection = node.querySelector( '.map-section' )
		this.mapToggle = node.querySelector( '.toggle-map__mobile' )
		this.restButton = node.querySelector( '.facetwp-reset' )

		this.addonData = window.webfxPropertyManagerData
	}
		
		
	/**
	 * Initialize basic class functions
	 *
	 * @return {void}
	 */
	init() {
		this.initEventListeners()
		this.initPropertyBlocks()
		this.enableFilterByMap()
		this.checkSaleLeaseFilter()
		this.checkPropertyFilter()
		this.removeDuplicatePaginationSummary()

		this.default_zoom = FWP_MAP.map.zoom
		this.default_center = { lat: FWP_MAP.map.center.lat(), lng: FWP_MAP.map.center.lng() }
	}


	/**
	 * Attach event listeners
	 *
	 * @return {void}
	 */
	initEventListeners() {
		document.addEventListener( 'facetwp-loaded', this.handleFacetWPLoaded.bind( this ) )
		this.restButton.addEventListener( 'click', this.resetMapPosition.bind( this ) )
		this.mapToggle.addEventListener( 'click', this.toggleMapMobile.bind( this ) )
	}


	/**
	 * Initialize properties (using property block class)
	 *
	 * @return {void}
	 */
	initPropertyBlocks() {
		this.createPropertyBlocks()
	}

	enableFilterByMap() {
		console.log( 'enableFilterByMap' )
		if ( 'undefined' === typeof FWP_MAP  ) {
			return
		}

		// Disable filter by Map on Mobile if Map is hidden! 
		var showMapBtn = document.querySelector('.toggle-map__mobile')
		if (showMapBtn) {
			var isVisible = window.getComputedStyle(showMapBtn).display === 'block';
			var isTextShowMap = showMapBtn.textContent.trim() === 'Show Map';
			if ( isVisible && isTextShowMap ) {
				FWP_MAP.is_filtering = false
				FWP_MAP.enableFiltering = false
				return
			}
		}

		var filterButton = document.querySelector( '.facetwp-map-filtering' )
		if ( !filterButton.classList.contains( 'enabled' ) && 'undefined' == typeof FWP_MAP.enableFiltering ) {
			filterButton.innerText = FWP_JSON['map']['resetText']
			FWP_MAP.is_filtering = true
			filterButton.classList.add( 'enabled' )
			FWP_MAP.enableFiltering = true
		}

		
	}

	/**
	 * When the sales/lease filter is changed, show/hide the appropriate price filter. 
	 */
	checkSaleLeaseFilter() {
		let salesLeaseSelect = document.querySelector( '.facet--main_listings_sales_lease select' )
		if ( !salesLeaseSelect ) return

		let selectValue = salesLeaseSelect.value
		let leasePriceFilter = document.querySelector( '.facetwp-facet-main_listings_lease_rate' ).parentElement
		let salePriceFilter = document.querySelector( '.facetwp-facet-main_listings_price' ).parentElement

		if ( 'lease' === selectValue ) {
			if ( 0 < FWP.facets['main_listings_price'].length ) {
				FWP.reset( 'main_listings_price' )
			}
			leasePriceFilter.style.display = 'block'
			salePriceFilter.style.display = 'none'
		} else if ( 'sale' === selectValue ) {
			if ( 0 < FWP.facets['main_listings_lease_rate'].length ) {
				FWP.reset( 'main_listings_lease_rate' )
			}
			leasePriceFilter.style.display = 'none'
			salePriceFilter.style.display = 'block'
		} else {
			leasePriceFilter.style.display = 'block'
			salePriceFilter.style.display = 'block'
		}
	}

	/**
	 * When the property filter is land, show size filter in acres.
	 */
	checkPropertyFilter() {
		let landToggle = document.querySelector( '.facetwp-facet-main_listings_land .facetwp-checkbox' )
		if ( !landToggle ) return
		
		let sqftSizeFilter = document.querySelector( '.facetwp-facet-main_listings_size' ).parentElement
		let acreSizeFilter = document.querySelector( '.facetwp-facet-main_listings_size_acres' ).parentElement

		if ( landToggle.classList.contains( 'checked' ) ) {
			if ( 0 < FWP.facets['main_listings_size'].length ) {
				FWP.reset( 'main_listings_size' )
			}
			if ( 0 < FWP.facets['main_listings_property_type'].length ) {
				FWP.reset( 'main_listings_property_type' )
			}
			sqftSizeFilter.style.display = 'none'
			acreSizeFilter.style.display = 'block'
		} else {
			if ( 0 < FWP.facets['main_listings_size_acres'].length ) {
				FWP.reset( 'main_listings_size_acres' )
			}
			sqftSizeFilter.style.display = 'block'
			acreSizeFilter.style.display = 'none'
		}
	}

	removeDuplicatePaginationSummary() {
		let loadmoreBtn = document.querySelector( '.facetwp-load-more' )
		loadmoreBtn.addEventListener( 'click', function() {
			let duplicatePaginationSummary = document.querySelector( '.properties__pagination__summary' )
			if ( duplicatePaginationSummary ) {
				duplicatePaginationSummary.remove()
			}
		})
	}

	/**
	 * Get property data for markers.
	 * 
	 * If no FacetWP filters are active, then use default map data, which should include all properties.
	 * 
	 * If FacetWP filter *is* active, then pull from listings node, which contains data for properties currently 
	 * visible in the listings node..
	 *
	 * @return {array} Property data for markers
	 */
	getDataForMarkers() {
		let data = this.addonData.propertiesMapData
		if( getActiveFacets().length ) {
			if( this.nodeListings ) {
				data = JSON.parse( this.nodeListings.dataset.mapPropertyData )
			}
		}

		return data
	}


	/**
	 * Create instances from the property block class
	 *
	 * @param {boolean} emptyPrev If true, empty previous property blocks
	 * @return {void}
	 */
	createPropertyBlocks( emptyPrev = false ) {
		const nodePropertyBlocks = this.node.querySelectorAll( '.js-property' )

		if( emptyPrev ) {
			this.propertyBlocks = []
		}

		nodePropertyBlocks.forEach( node => {
			const propertyBlock = new PropertyBlock( node )

			propertyBlock.init()

			this.propertyBlocks.push( propertyBlock ) 
		})
	}

	toggleMapMobile() {
		this.mapSection.classList.toggle( 'is-visible' )

		if ( this.mapSection.classList.contains( 'is-visible' ) ) {
			this.mapToggle.innerHTML = 'Hide Map'
		} else {
			this.mapToggle.innerHTML = 'Show Map'
		}
	}

	resetMapPosition() {
		FWP_MAP.map.setCenter( this.default_center )
		FWP_MAP.map.setZoom( this.default_zoom )
	}

	/**
	 * Handle FacetWP loaded event
	 *
	 * @param {Event} e
	 * @return {void}
	 */
	handleFacetWPLoaded( e ) {
		this.enableFilterByMap()
		this.checkSaleLeaseFilter()
		this.checkPropertyFilter()
		this.removeDuplicatePaginationSummary()
		// handles initializing property block sliders, favorite btns, etc
		this.createPropertyBlocks( true )

		// re-attach updated node listings block
		this.nodeListings = this.node.querySelector( '.js-main-listings-list' )
	}

}
